import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DropdownService } from 'src/app/_services/dropdown.service';

@Component({
  selector: 'app-navmenu-dropdown',
  standalone: false,
  templateUrl: './navmenu-dropdown.component.html',
  styleUrls: ['./navmenu-dropdown.component.scss']
})
export class NavmenuDropdownComponent implements OnInit {
  hidden = true;

  @Input() item: any;
  @Input() expanded: boolean;
  @Output() toggle = new EventEmitter<void>();

  constructor(private router: Router, private dropdownService: DropdownService) { }


  getIconForItem(itemName: string): string {
    const iconMap: { [key: string]: string } = {
      'Reportes': 'assessment',
      'Admisiones': 'how_to_reg',
      'Recursos educativos': 'store',
      'Estudio': 'library_books',
      'Plataformas': 'apps',

    };

    return iconMap[itemName] || 'folder';
  }


  ngOnInit() {
    if (this.isChildActive()) {
      this.hidden = false;
    }

    this.dropdownService.openedComponent$.subscribe((component) => {
      if (component !== this) {
        this.hidden = true;
      }
    });
  }


  toggleMenu() {
    if (this.hidden) {
      this.dropdownService.notifyOpen(this);
    }
    this.hidden = !this.hidden;
  }

  isChildActive(): boolean {
    if (!this.item.apps || this.item.apps.length === 0) return false;
    return this.item.apps.some((app: any) =>
      this.router.isActive(this.router.createUrlTree([app.url]), {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })
    );
  }

  handleExternalClick(event: Event) {
    event.preventDefault();
    const target = event.currentTarget as HTMLAnchorElement;
    window.open(target.href, '_blank');
    this.toggle.emit();
  }
}
